import CRUD from './genericCRUD'

const route = 'planting_media'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function plantingMedium(instance) {
	return {
		/**
		 * CRUD creates  the Create,Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} name
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''

			return instance.get(`${route}?${params}${nameParam}`, config)
		},

		/**
		 * @param {number} id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		patch: (id, body, config = {}) => {
			return instance.patch(`${route}/${id}`, body, config)
		}
	}
}
